export default {
    'FormularioFlujo.GuardarFlujo': ' Crear Flujo',
    'FormularioFlujo.EditarFlujo': 'Editar Flujo',
    'FormularioFlujo.flujoDescripcion': 'Descripción',
    'FormularioFlujo.Estado': 'Estado',
    'FormularioFlujo.Guardar': 'Guardar',
    'FormularioFlujo.Editar': 'Editar',
};
